'use strict';


import { createHtmlElement } from '../../../functions';

export class Range {
    constructor (parent,min,max,step,value) {
        this.parent = parent;
        this.rangeContainer = createHtmlElement(this.parent,'','div',['range']);
        this.element = createHtmlElement(this.rangeContainer,'','input',['range__input']);
        this.element.type = 'range';
        this.element.min = min;
        this.element.max = max;
        this.element.step = step;
        this.element.value = value;

        return this;
    }

    addListener(type, listener) {
        this.element.addEventListener(type, listener);
    }

    enable() {
        this.element.removeAttribute('disabled');
    }

    disable() {
        this.element.setAttribute('disabled',true);
    }

    classToggle(className) {
        this.element.classList.toggle(className);
    }

    removeClass(className) {
        this.element.classList.remove(className);
    }
    
    vertical() {
        this.rangeContainer.classList.add('--vertical-range');
    }

}
